





















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { expensesCollection, inventoryCollection } from "../db";
import { numeric } from "vee-validate/dist/rules";

@Component
export default class EquipmentExpensesReport extends Vue {
  @Getter expenses;

  private equipmentExpensesCollection;
  private equipmentExpenses: any[] = [];

  @Prop({ required: true })
  public item: any;

  private rules = {
    numeric: (x) => numeric.validate(x) || "Number required",
  };

  async created() {
    this.equipmentExpensesCollection = inventoryCollection
      .doc(this.item.id)
      .collection("expenses");

    this.$bind(
      "equipmentExpenses",
      this.equipmentExpensesCollection,
      { wait: true }
    );
  }

  get addList() {
    return this.expenses.filter((x) => {
      return !this.equipmentExpenses.some((a) => a.ref != null && a.ref.id == x.id);
    });
  }

  get displayList() {
    // After adding new expense, its not populated yet on ref, this filter makes it wait before updating the list
    return this.equipmentExpenses.filter(x => typeof(x.ref) == 'object' )
     .sort( (a, b) => {
       return a.ref.text.localeCompare(b.ref.text);
     });
  }

  get total() {
    let total = Number.parseFloat(this.item.purchasePrice);
    for (const expense of this.equipmentExpenses) {
      const f = parseFloat(expense.value);
      if (!isNaN(f)) {
        total += f;
      }
    }
    return total;
  }

  get profitPercent() {
    return Math.round((this.item.price / this.total - 1) * 100);
  }

  async add(expense) {
    await this.equipmentExpensesCollection.add({
      ref: expensesCollection.doc(expense.id),
      comments: "",
      value: "0",
    });
  }

  async update(value, id, type) {
    const obj = {};
    obj[type] = value;
    await this.equipmentExpensesCollection.doc(id).update(obj);
  }

  async remove(id) {
    await this.equipmentExpensesCollection.doc(id).delete();
  }
}
